import { useQuery } from '@tanstack/react-query';
import restClient from '../common/api/restClient';

export const useShowBanner = (section) => {
  const prefix = process.env.REACT_APP_PROXY_PREFIX || '';
  const query = useQuery({
    queryKey: ['showBanner', section],
    queryFn: async () => {
      const result = await restClient({ url: `${prefix}/banner/section${section}` });
      return result;
    },
    staleTime: 0,
    cacheTime: 0
  });

  return query;
};
